export enum HeaderHeights {
  Desktop = 36,
  Mobile = 56
}
